import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration

/**
 * AdminUserView class extends JetView to create a user management interface.
 */
export default class AdminUserView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        return {
            type: 'clean',
            view: 'form',
            id: 'a10',
            scroll: 'y',
            rows: [
                {
                    type: 'wide',
                    responsive: 'a10',
                    margin: 10,
                    cols: [
                        {
                            localId: 'inner:layout', // Local ID for inner layout
                            gravity: 4,
                            type: 'wide',
                            rows: [
                                {
                                    view: 'toolbar', // Toolbar for navigation
                                    css: theme, // Apply theme to toolbar
                                    elements: [
                                        {
                                            width: 30,
                                            css: 'back-button', // CSS class for back button
                                            view: 'button',
                                            type: 'icon',
                                            icon: 'wxi-angle-left', // Icon for back button
                                            id: 'security.adminuser', // Unique ID for button
                                            align: 'center',
                                            click: () => {
                                                // Click event to navigate back
                                                this.show('../adminUser');
                                            },
                                        },
                                        {
                                            css: 'user-selected', // CSS class for label
                                            view: 'label',
                                            id: 'lblTittle', // Unique ID for label
                                            align: 'center',
                                        },
                                    ],
                                },
                                {
                                    view: 'tabbar', // Tab bar for navigation
                                    localId: 'tabbar', // Local ID for tab bar
                                    height: 35,
                                    options: [
                                        {
                                            id: 'security.adminuser.informationAdminUser', // ID for information tab
                                            value: _('Información'), // Localized value
                                        },
                                        {
                                            id: 'security.adminuser.reportsAdminUser/security.adminuser.reports.logsUser', // ID for reports tab
                                            value: _('Reportes'), // Localized value
                                        },
                                        {
                                            id: 'security.adminuser.configurationAdminUser/security.adminuser.configuration.changePassword', // ID for configuration tab
                                            value: _('Configuración'), // Localized value
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter
        );
        const cur_user = this.getParam('user', true); // Get current user ID
        const _ = this.app.getService('locale')._; // Localization service
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientById', // API endpoint to get client by ID
            'id=' + cur_user, // Query parameter
            {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! '); // Display error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    data = JSON.parse(text); // Parse response data
                    $$('lblTittle').setValue(
                        // Update label with user information
                        "<div class='username-active'><span class='icon-user'></span><div style='font-weight: normal'>" +
                            _('Usuario:') +
                            ' &nbsp;</div><div>' +
                            data[0].Login + // Display user's login
                            '</div></div>',
                    );
                },
            },
        );
    }
}

// FILE DOCUMENTED
